import { useSelector } from 'react-redux';

import { RootState } from '../../rootReducer';

export const useTextId = (): string | null => {
  return useSelector<RootState, string | null>(state => state.text.textId);
};
